import { Box, Grid } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { routeName } from 'routes/routes-name';

/** TRANSLATION*/
import { useTranslation } from 'react-i18next';

/**API */
import ClinicApi from 'api/master/clinic.api';
import ReportApi, { FindAllReportInterface } from 'api/report.api';
import { getBranch, toBuddhistYear } from 'utils/app.utils';

/**COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard';
import InputSecondNewDatePicker, { PICKER_VIEWS } from 'component/Input/InputSecondNewDatePicker';
import Loading from 'component/Loading';
import FucntionPrint from "component/Print/print";
import LabOperativeList from './LabOperativeList';

/**STYLE */
import * as UseStyled from 'features/report/useStyled';

import MainButton from 'new-components/buttons/main-button';
import RadioButton from 'new-components/buttons/radio-button';
import SelectInput from 'new-components/inputs/select-input';
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input';
import { UseSnCode } from 'utils/useSnCode';
import { exportLabOpreativeToExcelDay } from './exportLabOperativeToExcelDay';
import { exportLabOpreativeToExcelMonth } from './exportLabOperativeToExcelMonth';

type Doctors = {
    userId: number
    firstname: string
    lastname: string
    fullname: string
    schedule: number | null
}

export interface DentistInterface {
    dentistId: number
    dentistFullname: string
}

export default function Df() {
    const { t } = useTranslation();
    const history = useHistory();
    const componentRef = useRef<HTMLDivElement>(null);
    const queryParams = new URLSearchParams(window.location.search)
    const userIdFromParam = Number(queryParams.get("doctorId"))
    const momentNow = moment().format('YYYY-MM-DD');
    const [branchId, setBranchId] = useState<any>(getBranch());
    const [branches, setBranches] = useState<any[]>([]);
    const [rowCount, setRowCount] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>('createAt');
    const [sortType, setSortType] = useState<string>('ASC');
    const [doctors, setDoctors] = useState<Doctors[]>([]);
    const [fetch, setFetch] = useState(false);
    const [dfData, getDfData] = useState<any[]>([]);
    const [date, setDate] = useState<string>(momentNow);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [display, setDisplay] = useState('day');
    const [loading, setLoading] = useState<boolean>(true);
    const [selectDoctors, setSelectDoctors] = useState<any[]>([])
    const [doctorSchedule, setDoctorSchedule] = useState<any[]>([])

    const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([]);
    const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

    const [snType, setSnType] = useState(false)

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode()
            setSnType(sn)
        }

        fetchData()
    }, [snType])

    const getAllFilter = () => {
        return [{
            label: t('REPORT.FILTER.BRANCH'),
            value: _.get(_.find(branches, { branchId }), 'branchName') || _.get(_.find(branches, { branchId }), 'branchNameEn'),
        },
        {
            label: display === 'day' ? t('REPORT.FILTER.DAY') : t('REPORT.FILTER.MONTH'),
            value: display === 'day' ? toBuddhistYear(moment(date), 'DD/MM/YYYY') : toBuddhistYear(moment(date), 'MMMM YYYY'),
        },
        {
            label: t('REPORT.FILTER.DOCTOR'),
            value: getFilterUser()
        }]
    }


    const getFilterUser = () => {
        if (_.includes(selectDoctors, 'ALL')) return t('REPORT.REPORT_GROUP.ALL')
        else {
            return ` ${doctorsMultiple
                .filter((d: DentistInterface) => selectDoctors.includes(d.dentistId))
                ?.map((d: DentistInterface) => d.dentistFullname)
                .join(', ')}`
        }
    }

    const verifyPermission = async () => {
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data))
            .catch((e) => { return })
        if (!userIdFromParam) {
            const condition: FindAllReportInterface = {
                page: 1, pageLimit: 200
            }
            ReportApi.reportList(condition)
                .then(({ data }) => {
                    const check = _.find(data, (val: any) => String(val.reportKey) === 'DF_LAB_OPERATIVE') ? true : false
                    if (!check) {
                        history.push(routeName.report)
                        return false
                    }
                })

        }
        return true
    }

    useEffect(() => {
        verifyPermission()
    }, [branchId])

    const fetchDF = useCallback(async () => {
        let condition: any = {
            page: page, pageLimit: pageLimit,
            branchId: branchId, date: date,
            display: display
        }

        if (doctors) {
            const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
            if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
        }
        if (userIdFromParam) condition = { ...condition, doctorId: userIdFromParam }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }


        ReportApi.reportDfLabOperative(condition)
            .then(({ headers, data }) => {
                getDfData(data)
                setRowCount(headers['x-total'])
            }).catch((e) => setLoading(false))
            .finally(() => {
                setLoading(false)
            })
        setFetch(false)
        handleSnCode()

    }, [page, pageLimit, sortBy, sortType, fetch, display])

    useEffect(() => {
        if (date !== 'Invalid date' && date) {
            ClinicApi.findAllDoctors(date, display, date, date)
                .then((resp) => {
                    setDoctors([...resp.data])
                    setDoctorSchedule(_.map(_.filter(resp.data, (d) => d.userId === d.schedule), (d: any) => d.userId))
                    setSelectDoctors(['ALL', 'DOCTOR_SCHEDULE', ...resp.data.map((d: any) => d.userId)])
                })
                .catch((e) => {
                    return
                })
        }
    }, [date])

    const fetchDoctor = useCallback(async () => {
        ClinicApi.findAllDoctors(date, display, date, date)
            .then((resp) => {
                setDoctors([...resp.data])
                setDoctorSchedule(_.map(_.filter(resp.data, (d) => d.userId === d.schedule), (d: any) => d.userId))
                setSelectDoctors(['ALL', 'DOCTOR_SCHEDULE', ...resp.data.map((d: any) => d.userId)])
            })
            .catch((e) => {
                return
            })
    }, [branchId, date, display])

    const onDownload = () => {
        const filter = getAllFilter().map((e: any) => {
            return `${e.label}: ${e.value}`
        })
        const report: any = {
            title: t('REPORT.REPORT_NAME.DF_LAB_OPERATIVE'),
            statusFilter: filter.join('        '),
            data: dfData,
            snType: !snType,
            t: t
        }
        if (display === 'day') exportLabOpreativeToExcelDay(report)
        else exportLabOpreativeToExcelMonth(report)

    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

    const handleChangePage = (val: number) => setPage(val)


    useEffect(() => {
        fetchDoctor()
    }, [fetchDoctor])

    useEffect(() => {
        fetchDF()
    }, [fetchDF])

    return (
        <>
            <Box >
                <HeaderCard text={t(`REPORT.REPORT_NAME.DF_LAB_OPERATIVE`)} />
                <Box sx={{ px: 3, pt: 2 }}>
                    <RadioButton
                        name=""
                        onChange={e => {
                            setDisplay(e.target.value);
                        }} options={[
                            { label: t('REPORT.MONTH.DAYLY'), value: 'day' },
                            { label: t('REPORT.MONTH.MONTHLY'), value: 'month' }
                        ]}
                        row
                        toolTip
                        defaultValue="day"
                    />

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3} xl={2}>
                            <SelectInput
                                label={t('REPORT.FILTER.BRANCH')}
                                value={branchId}
                                onChange={e => {
                                    setBranchId(Number(e.target.value));
                                    setPage(1);
                                }}
                                options={branches.map(b => ({
                                    value: b.branchId,
                                    name: b.branchName || b.branchNameEn || ''
                                }))}
                                width="100%"
                            />
                        </Grid>

                        {display === 'day' && (
                            <Grid item xs={12} sm={6} md={3} xl={2}>
                                <InputSecondNewDatePicker
                                    dateFormat={'DD/MM/YYYY'}
                                    placeholder={t('REPORT.FILTER.DATE')}
                                    label={''}
                                    inputHeight={40}
                                    value={date}
                                    onchange={(e: any) => {
                                        setDate(moment(e).format('YYYY-MM-DD'))
                                        setPage(1)
                                    }}
                                    views={PICKER_VIEWS.DAY || PICKER_VIEWS.MONTH || PICKER_VIEWS.YEAR}
                                />
                            </Grid>
                        )}

                        {display === 'month' && (
                            <Grid item xs={12} sm={6} md={3} xl={2}>
                                <InputSecondNewDatePicker
                                    dateFormat={`MMMM YYYY`}
                                    placeholder={t('REPORT.FILTER.DATE')}
                                    label={''}
                                    inputHeight={40}
                                    value={date}
                                    onchange={(e: any) => {
                                        setDate(moment(e).format('YYYY-MM-DD'))
                                        setPage(1)
                                    }}
                                    views={PICKER_VIEWS.MONTH}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={6} md={3} xl={2}>
                            {!userIdFromParam && (
                                <SelectCheckBoxInput
                                    label={t('USER_DOCTOR')}
                                    options={[
                                        { id: 'DOCTOR_SCHEDULE', name: t('REPORT.FILTER.DOCTOR_SCHEDULE') },
                                        ...doctors.map((d: any) => ({ id: d.userId, name: d.fullname })),
                                    ]}
                                    selected={selectDoctors}
                                    onChange={(ids: any) => {
                                        if (ids.includes('DOCTOR_SCHEDULE') && ids.length === 1) {
                                            const currentSchedule = doctorSchedule.every((id) => selectDoctors.includes(id));
                                            const newSelected = new Set(selectDoctors);
                                            if (currentSchedule) {
                                                doctorSchedule.forEach((id) => newSelected.delete(id));
                                            } else {
                                                doctorSchedule.forEach((id) => newSelected.add(id));
                                            }
                                            setSelectDoctors(['DOCTOR_SCHEDULE', ...Array.from(newSelected)]);
                                            return;
                                        }
                                        setSelectDoctors(ids)
                                        setOpenFilterDoctors(false)
                                    }}
                                    fullWidth
                                    width="100%"
                                />)}
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} xl={6} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <MainButton
                                title={t('INPUT.SEARCH')}
                                type="primary"
                                variant="contained"
                                onClick={() => {
                                    setFetch(true);
                                    setPage(1);
                                    setLoading(true);
                                }}
                                style={{ width: '120px' }}
                            />


                            <Box >
                                <UseStyled.DropdownDocument>
                                    <Dropdown.Toggle id="dropdown-basic" className='ml-xl-auto'>
                                        {t('PRINT_DOCUMENT')}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onDownload}>
                                            {t('Excel')}
                                        </Dropdown.Item>
                                        <FucntionPrint
                                            content={() => componentRef.current}

                                            removeIfram
                                            trigger={() => <Dropdown.Item >
                                                {t('PDF')}
                                            </Dropdown.Item>}
                                            style={`@page { size:  1122.519685px 793.7007874px;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                                        />
                                    </Dropdown.Menu>
                                </UseStyled.DropdownDocument>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
                        <LabOperativeList
                            filterTable={getAllFilter()}
                            page={page}
                            pageLimit={pageLimit}
                            rowCount={rowCount}
                            sortBy={sortBy}
                            sortType={sortType}
                            data={dfData}
                            date={date}
                            display={display}
                            onRequestSort={onRequestSort}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            handleChangePage={handleChangePage}
                            componentRef={componentRef}
                        />
                    </Box>
                </Box>
                <Loading show={loading} type='fullLoading' />
            </Box>
        </>
    )
}